import { createReducer, byIdAndValues } from 'src/utils/reducer'
import {
    asyncUpdateRunbookSession,
    collectHiddenActionUids,
} from 'src/store/modules/runbooks'
import * as actions from 'src/constants/actionTypes'
import { SUPPLIERS_URL } from 'src/constants/urls'
import uniq from 'lodash/uniq'

const suppliers = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
        modalOpen: false,
        errors: {},
    },
    {
        [actions.GET_SUPPLIERS_SUCCESS]: (state, action) => {
            return {
                ...state,
                ...byIdAndValues(action.payload.data.results),
            }
        },
        [actions.SAVE_SUPPLIER]: (state) => {
            return {
                ...state,
                errors: {},
            }
        },
        [actions.SAVE_SUPPLIER_SUCCESS]: (state, action) => {
            const contact = action.payload.data
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [contact.id]: contact,
                },
                values: uniq([...state.values, contact.id]),
                modalOpen: false,
            }
        },
        [actions.SAVE_SUPPLIER_ERROR]: (state, action) => {
            return {
                ...state,
                errors: action.error.response.data,
            }
        },
        [actions.DELETE_SUPPLIER_SUCCESS]: (state, action) => {
            const { byId, values } = state
            delete byId[action.id]
            return {
                ...state,
                byId: { ...byId },
                values: values.filter((id) => id !== action.id),
            }
        },
        [actions.OPEN_SUPPLIER_MODAL]: (state) => {
            return {
                ...state,
                modalOpen: true,
                errors: {},
            }
        },
        [actions.CLOSE_SUPPLIER_MODAL]: (state) => {
            return {
                ...state,
                modalOpen: false,
                errors: {},
            }
        },
    }
)

export const saveSupplier = (id, data, runbookId, actionId) => (
    dispatch,
    getState
) => {
    const method = id ? 'put' : 'post'
    const url = `${SUPPLIERS_URL}${id ? id + '/' : ''}`
    return dispatch({
        type: actions.API,
        method,
        data,
        payload: {
            url,
            start: () => ({ type: actions.SAVE_SUPPLIER }),
            success: (payload) => {
                if (runbookId) {
                    // Get runbook state and collect hidden action UIDs
                    const state = getState()
                    const runbook = state.runbooks?.byId?.[runbookId]
                    const hiddenActionUids = collectHiddenActionUids(
                        runbook?.actions?.byId
                    )

                    dispatch(
                        asyncUpdateRunbookSession(
                            runbookId,
                            [actionId],
                            {
                                action: 'transfer',
                                contactType: 'supplier',
                                label: payload.data.email,
                                id: payload.data.id,
                            },
                            hiddenActionUids
                        )
                    )
                }
                return {
                    type: actions.SAVE_SUPPLIER_SUCCESS,
                    payload,
                    runbookId,
                    actionId,
                }
            },
            error: (error) => ({
                type: actions.SAVE_SUPPLIER_ERROR,
                error,
            }),
        },
    })
}

export const deleteSupplier = (id) => {
    return {
        type: actions.API,
        method: 'delete',
        payload: {
            url: `${SUPPLIERS_URL}${id}/`,
            start: () => ({ type: actions.DELETE_SUPPLIER }),
            success: (payload) => ({
                type: actions.DELETE_SUPPLIER_SUCCESS,
                payload,
                id,
            }),
            error: (error) => ({
                type: actions.DELETE_SUPPLIER_ERROR,
                error,
            }),
        },
    }
}

export const getSuppliersFromServer = () => {
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url: SUPPLIERS_URL,
            start: () => ({ type: actions.GET_SUPPLIERS }),
            success: (payload) => ({
                type: actions.GET_SUPPLIERS_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.GET_SUPPLIERS_ERROR,
                error,
            }),
        },
    }
}

export const openSupplier = () => ({
    type: actions.OPEN_SUPPLIER_MODAL,
})

export const closeSupplier = () => ({
    type: actions.CLOSE_SUPPLIER_MODAL,
})

export const getSupplierById = (state, id) => state.cmdb.suppliers.byId[id]

export const getSuppliers = (state) =>
    state.cmdb.suppliers.values.map((id) => state.cmdb.suppliers.byId[id])

export default suppliers
